module.exports = __webpack_public_path__ + "static/img/anxun112.6c8f2b6b.jpg";